import { EFinancingProgram } from '@if/core/types'
import { Navigate } from 'react-router-dom'
import { useUserSupportsProgram } from '../ViewCreditApplicationPage/credit-hooks'
import ProductsCalculator from './components/ProductsCalculator'
import PersonalLoanCalculator from './components/PersonalLoanCalculator'

const CalculatorPage = () => {
  const supportsProducts = useUserSupportsProgram(EFinancingProgram.Products)
  const supportsPersonal = useUserSupportsProgram(EFinancingProgram.Personal)

  // Guard the page itself (the nav entry uses the same condition): the calculator
  // is only for merchants that support a financing program. Redirect otherwise so
  // the route isn't reachable directly. Each calculator owns its PageContainer.
  if (!supportsProducts && !supportsPersonal) return <Navigate to="/" replace />

  return (
    <>
      {supportsProducts && <ProductsCalculator />}
      {supportsPersonal && <PersonalLoanCalculator />}
    </>
  )
}

export default CalculatorPage
